import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { Avatar, Button, Divider, List, Menu, Modal, Space } from 'antd';
import Icon from '@mdi/react';
import {
  mdiAccountCashOutline,
  mdiClose,
  mdiCloudCheckOutline,
  mdiEmailOutline,
  mdiGithub,
  mdiMovieOpenOutline,
} from '@mdi/js';
import { URL } from '../../_config';
import { UserMenu } from '../../components/Sidebar';
import { logo } from '../../assets/svg/logos';

const Learn = () => {
  const { t } = useTranslation();
  const data = [
    <a key="wisdomLink" href={URL.WISDOM} target="_blank" rel="noreferrer">
      <Space align="center">
        <Icon path={mdiGithub} />
        <span>{t('dashboard.documentation')}</span>
      </Space>
    </a>,
    <a key="youtubeLink" href={URL.YOUTUBE} target="_blank" rel="noreferrer">
      <Space align="center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <g>
            <path fill="none" d="M0 0h24v24H0z" />
            <path
              fillRule="nonzero"
              d="M19.606 6.995c-.076-.298-.292-.523-.539-.592C18.63 6.28 16.5 6 12 6s-6.628.28-7.069.403c-.244.068-.46.293-.537.592C4.285 7.419 4 9.196 4 12s.285 4.58.394 5.006c.076.297.292.522.538.59C5.372 17.72 7.5 18 12 18s6.629-.28 7.069-.403c.244-.068.46-.293.537-.592C19.715 16.581 20 14.8 20 12s-.285-4.58-.394-5.005zm1.937-.497C22 8.28 22 12 22 12s0 3.72-.457 5.502c-.254.985-.997 1.76-1.938 2.022C17.896 20 12 20 12 20s-5.893 0-7.605-.476c-.945-.266-1.687-1.04-1.938-2.022C2 15.72 2 12 2 12s0-3.72.457-5.502c.254-.985.997-1.76 1.938-2.022C6.107 4 12 4 12 4s5.896 0 7.605.476c.945.266 1.687 1.04 1.938 2.022zM10 15.5v-7l6 3.5-6 3.5z"
            />
          </g>
        </svg>
        <span>{t('dashboard.youtube_channel')}</span>
      </Space>
    </a>,
    <Menu key="youtubeChannels" triggerSubMenuAction="click" selectable={false}>
      <Menu.SubMenu
        key="youtubeUnofficialChannels"
        title={
          <Space align="center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <g>
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                  fillRule="nonzero"
                  d="M19.606 6.995c-.076-.298-.292-.523-.539-.592C18.63 6.28 16.5 6 12 6s-6.628.28-7.069.403c-.244.068-.46.293-.537.592C4.285 7.419 4 9.196 4 12s.285 4.58.394 5.006c.076.297.292.522.538.59C5.372 17.72 7.5 18 12 18s6.629-.28 7.069-.403c.244-.068.46-.293.537-.592C19.715 16.581 20 14.8 20 12s-.285-4.58-.394-5.005zm1.937-.497C22 8.28 22 12 22 12s0 3.72-.457 5.502c-.254.985-.997 1.76-1.938 2.022C17.896 20 12 20 12 20s-5.893 0-7.605-.476c-.945-.266-1.687-1.04-1.938-2.022C2 15.72 2 12 2 12s0-3.72.457-5.502c.254-.985.997-1.76 1.938-2.022C6.107 4 12 4 12 4s5.896 0 7.605.476c.945.266 1.687 1.04 1.938 2.022zM10 15.5v-7l6 3.5-6 3.5z"
                />
              </g>
            </svg>
            <span>{t('dashboard.youtube_unofficial_channel')}</span>
          </Space>
        }
        style={{ padding: 0 }}
      >
        {URL.YOUTUBE_UNOFFICIAL.map(({ avatar, name, url }, i) => (
          <Menu.Item key={`unofficial-${i}`}>
            <a href={url} target="_blank" rel="noreferrer">
              <Space align="center">
                <Avatar size="small" src={avatar} />
                <span>{name}</span>
              </Space>
            </a>
          </Menu.Item>
        ))}
      </Menu.SubMenu>
    </Menu>,
  ];
  return (
    <List
      header={
        <Divider orientation="left" className="mb-0">
          <span>{t('dashboard.learn')}</span>
        </Divider>
      }
      dataSource={data}
      renderItem={(item) => <List.Item>{item}</List.Item>}
    />
  );
};

const Help = () => {
  const { t } = useTranslation();
  const [isHireExpertVisible, setHireExpertVisible] = useState(false);
  const data = [
    <Menu key="discordChannels" triggerSubMenuAction="click" selectable={false}>
      <Menu.SubMenu
        key="discordCommunity"
        title={
          <Space align="center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              width="48"
              height="48"
              viewBox="0 0 48 48"
            >
              <path d="M 31.845703 7.0332031 C 31.571975 7.0271225 31.299556 7.046358 31.033203 7.0898438 C 29.435088 7.3507584 28.030508 8.4695888 27.488281 10.091797 C 27.370384 10.444321 27.264005 10.796966 27.175781 11.154297 C 25.826782 11.030712 24.699008 11.007813 24 11.007812 C 23.300992 11.007812 22.173218 11.030712 20.824219 11.154297 C 20.736067 10.797605 20.629411 10.445663 20.511719 10.09375 C 19.969492 8.471542 18.564912 7.3527115 16.966797 7.0917969 C 16.434092 7.0048284 15.87903 7.0144079 15.328125 7.1308594 C 13.118088 7.5982452 9.9617245 8.5051099 7.4726562 10.525391 A 1.50015 1.50015 0 0 0 7.3945312 10.59375 C 6.6089575 11.326512 6.0671471 12.315967 5.3984375 13.710938 C 4.7297279 15.105906 4.0361619 16.860751 3.3984375 18.861328 C 2.1229888 22.862483 1.0742188 27.837935 1.0742188 32.769531 A 1.50015 1.50015 0 0 0 1.2675781 33.505859 C 3.613117 37.667886 8.7053413 39.246064 11.824219 39.875 C 13.544661 40.221791 15.316939 39.515364 16.34375 38.091797 L 17.580078 36.376953 C 19.428026 36.763851 21.567209 37.019531 24 37.019531 C 26.432791 37.019531 28.571974 36.763851 30.419922 36.376953 L 31.654297 38.089844 C 32.680716 39.514931 34.455173 40.219871 36.175781 39.873047 C 39.294659 39.244111 44.38493 37.665933 46.730469 33.503906 A 1.50015 1.50015 0 0 0 46.923828 32.767578 C 46.923828 27.835982 45.877011 22.860401 44.601562 18.859375 C 43.963839 16.858862 43.268305 15.103975 42.599609 13.708984 C 41.930913 12.313994 41.388626 11.324567 40.603516 10.591797 A 1.50015 1.50015 0 0 0 40.525391 10.523438 C 38.036503 8.5033004 34.881138 7.5963178 32.669922 7.1289062 C 32.394469 7.0706805 32.119432 7.0392837 31.845703 7.0332031 z M 31.769531 10.03125 C 31.861361 10.034073 31.955281 10.044679 32.048828 10.064453 C 34.002862 10.477501 36.746684 11.357206 38.580078 12.822266 C 38.703057 12.946693 39.310378 13.787237 39.894531 15.005859 C 40.488742 16.245463 41.142287 17.887669 41.742188 19.769531 C 42.900822 23.40412 43.814735 27.941895 43.878906 32.302734 C 42.219626 34.826111 38.165354 36.410702 35.582031 36.931641 C 35.01064 37.046816 34.443424 36.82685 34.089844 36.335938 L 33.509766 35.533203 C 34.110146 35.329457 34.674845 35.117908 35.177734 34.904297 C 37.691844 33.836383 39.082031 32.671875 39.082031 32.671875 A 1.5004047 1.5004047 0 1 0 37.134766 30.388672 C 37.134766 30.388672 36.18725 31.217945 34.005859 32.144531 C 31.824469 33.071117 28.505584 34.019531 24 34.019531 C 19.494416 34.019531 16.175531 33.071117 13.994141 32.144531 C 11.81275 31.217945 10.865234 30.388672 10.865234 30.388672 A 1.50015 1.50015 0 0 0 9.90625 30.015625 A 1.50015 1.50015 0 0 0 8.9179688 32.671875 C 8.9179688 32.671875 10.308156 33.836383 12.822266 34.904297 C 13.325155 35.117908 13.889854 35.329457 14.490234 35.533203 L 13.910156 36.337891 C 13.554968 36.830323 12.987573 37.050756 12.416016 36.935547 C 9.8326922 36.414607 5.7784209 34.828063 4.1191406 32.304688 C 4.1833118 27.943831 5.0972239 23.40619 6.2558594 19.771484 C 6.85576 17.889562 7.5112721 16.247343 8.1054688 15.007812 C 8.6896043 13.789271 9.2954195 12.948182 9.4179688 12.824219 C 11.251211 11.359285 13.995991 10.479481 15.949219 10.066406 C 16.697598 9.9082126 17.418985 10.305866 17.666016 11.044922 C 17.730238 11.236954 17.776769 11.414706 17.826172 11.59375 C 15.590745 12.037313 13.096912 12.807641 10.734375 14.210938 A 1.50015 1.50015 0 1 0 12.265625 16.789062 C 16.622816 14.200985 22.007572 14.007813 24 14.007812 C 25.992428 14.007812 31.377184 14.200984 35.734375 16.789062 A 1.50015 1.50015 0 1 0 37.265625 14.210938 C 34.902434 12.807252 32.40777 12.037244 30.171875 11.59375 C 30.221382 11.414209 30.267598 11.23563 30.332031 11.042969 C 30.548183 10.396295 31.12672 10.01149 31.769531 10.03125 z M 17.535156 22 A 3.465 3.96 0 0 0 17.535156 29.919922 A 3.465 3.96 0 0 0 17.535156 22 z M 30.445312 22 A 3.5 4 0 0 0 30.445312 30 A 3.5 4 0 0 0 30.445312 22 z"></path>
            </svg>
            <span>{t('dashboard.discord_community')}</span>
          </Space>
        }
        style={{ padding: 0 }}
      >
        <Menu.Item key="discordEsLink">
          <a href={URL.DISCORD_EN} target="_blank" rel="noreferrer">
            <span>English</span>
          </a>
        </Menu.Item>
        <Menu.Item key="discorEndLink">
          <a href={URL.DISCORD_ES} target="_blank" rel="noreferrer">
            <span>Español</span>
          </a>
        </Menu.Item>
      </Menu.SubMenu>
    </Menu>,
    <Button
      key="hirteExpert"
      type="link"
      onClick={() => setHireExpertVisible(true)}
    >
      <Space align="center">
        <Icon path={mdiAccountCashOutline} />
        <span>{t('dashboard.hire_expert')}</span>
      </Space>
    </Button>,
    <a
      key="feedbackLink"
      href="mailto:support@doyo.tech"
      target="_blank"
      rel="noreferrer"
    >
      <Space align="center">
        <Icon path={mdiEmailOutline} />
        <span>{t('dashboard.submit_feedback')}</span>
      </Space>
    </a>,
    <a key="twitterLink" href={URL.TWITTER} target="_blank" rel="noreferrer">
      <Space align="center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <g id="Layer_2" data-name="Layer 2">
            <g id="twitter">
              <g id="twitter-2" data-name="twitter">
                <path d="M8.51,20H8.43a10.87,10.87,0,0,1-4.65-1.09A1.38,1.38,0,0,1,3,17.47a1.41,1.41,0,0,1,1.16-1.18,6.63,6.63,0,0,0,2.54-.89A9.49,9.49,0,0,1,3.19,6.33a1.41,1.41,0,0,1,1-1.15,1.35,1.35,0,0,1,1.43.41,7.09,7.09,0,0,0,4.88,2.75,4.5,4.5,0,0,1,1.41-3.1,4.47,4.47,0,0,1,6.37.19.7.7,0,0,0,.78.1A1.39,1.39,0,0,1,21,7.13a6.66,6.66,0,0,1-1.28,2.6A10.79,10.79,0,0,1,8.51,20Zm0-2h.08a8.79,8.79,0,0,0,9.09-8.59,1.32,1.32,0,0,1,.37-.85,5.19,5.19,0,0,0,.62-1,2.56,2.56,0,0,1-1.91-.85A2.45,2.45,0,0,0,15,6a2.5,2.5,0,0,0-1.79.69,2.53,2.53,0,0,0-.72,2.42l.26,1.14-1.17.08a8.3,8.3,0,0,1-6.54-2.4,7.12,7.12,0,0,0,3.73,6.46l.95.54-.63.9a5.62,5.62,0,0,1-2.68,1.92A8.34,8.34,0,0,0,8.5,18ZM19,6.65h0Z" />
              </g>
            </g>
          </g>
        </svg>
        <span>Twitter</span>
      </Space>
    </a>,
  ];
  return (
    <>
      <List
        header={
          <Divider orientation="left" className="mb-0">
            <span>{t('dashboard.help')}</span>
          </Divider>
        }
        dataSource={data}
        renderItem={(item) => <List.Item>{item}</List.Item>}
      />
      <Modal
        title={t('dashboard.hire_expert')}
        closeIcon={<Icon path={mdiClose} size={1} />}
        open={isHireExpertVisible}
        cancelText={t('common.cancel')}
        okText={t('dashboard.request_expert')}
        onOk={() => window.open('mailto:support@doyo.email')}
        onCancel={() => setHireExpertVisible(false)}
      >
        {parse(t('dashboard.hire_expert_description'))}
      </Modal>
    </>
  );
};

const DoyoApps = () => {
  const data = [
    <a key="kustodioLink" href={URL.KUSTODIO} target="_blank" rel="noreferrer">
      <Space align="center">
        <Icon path={mdiCloudCheckOutline} />
        <span>Kustodio</span>
      </Space>
    </a>,
    <a
      key="doyoStoriesLink"
      href={URL.DOYOSTORIES}
      target="_blank"
      rel="noreferrer"
    >
      <Space align="center">
        <Icon path={mdiMovieOpenOutline} />
        <span>DoyoStories</span>
      </Space>
    </a>,
  ];
  return (
    <List
      header={
        <>
          <Divider orientation="left" className="mb-0">
            <span>Doyo Apps</span>
          </Divider>
        </>
      }
      dataSource={data}
      renderItem={(item) => <List.Item>{item}</List.Item>}
    />
  );
};

const Sidebar = ({ children, path }) => {
  return (
    <>
      <Space direction="vertical">
        <Link to="/" className="d-block mt-3 me-4 p-3">
          <img alt="logo Doyo" src={logo} height="28px" />
        </Link>
        <Learn />
        <Help />
        <DoyoApps />
      </Space>
      <div className="flex-grow-1" />
      <UserMenu />
    </>
  );
};

export default Sidebar;
export { Sidebar };
